import NextImage from 'next/image'
import { useStaticData } from '@mc/static-data-react'
import { type PrunedCourse } from 'libs/server/api'

export const InstructorAccolades = () => {
  const { course } = useStaticData<{
    course: PrunedCourse
  }>()
  const { instructorAccolades } = course

  if (!instructorAccolades || instructorAccolades.length === 0) {
    return null
  }

  return (
    <div
      className='d-flex align-items-center mc-gap-3 mc-p-3 mc-mt-3 mc-text--left'
      style={{ borderTop: '1px solid var(--mc-color-outline-disabled)' }}
    >
      <NextImage
        src={course.primary1x1 || ''}
        alt={course.instructorName || ''}
        width={40}
        height={40}
        className='mc-corners--circle flex-shrink-0'
        style={{ width: 30, height: 30, objectFit: 'cover' }}
      />
      <div className='mc-text--left'>
        <p className='mc-text-x-small'>
          {instructorAccolades[0]}
          {instructorAccolades.length > 1 && (
            <>
              <br />
              {instructorAccolades[1]}
            </>
          )}
        </p>
      </div>
    </div>
  )
}
